import type { FC, ReactNode } from 'react'

import Link from 'next/link'

import { NpvMark } from '@/components/generals/npv-mark'

import { navLinks } from '@/constants/nav'
import { siteConfig } from '@/constants/site'
import { SOS } from '@/constants/canais'

export const Footer: FC = (): ReactNode => {
    return (
        <footer className='ft-root' id='rodape'>
            <div className='ft-rule' aria-hidden='true' />

            <section className='ft-sos' aria-label="Canais gratuitos de ajuda">
                <p className='ft-sos-lead'>
                    Em perigo agora, ligue 190. Os canais abaixo são gratuitos.
                </p>

                <ul className='ft-sos-list'>
                    {SOS.map(item => (
                        <li key={item.numero}>
                            <a className='ft-sos-item' href={item.tel}>
                                <span className='ft-sos-num'>
                                    {item.numero}
                                </span>

                                <span className='ft-sos-label'>
                                    {item.label}
                                </span>
                            </a>
                        </li>
                    ))}
                </ul>
            </section>

            <div className='ft-grid'>
                <div className='ft-mark'>
                    <NpvMark className='ft-mark-icon' />

                    <span>
                        {siteConfig.name}
                        <span className='ft-mark-full'>
                            {siteConfig.fullName}
                        </span>
                    </span>
                </div>

                <nav className='ft-nav' aria-label="Rodapé">
                    {navLinks.map(link => (
                        <Link key={link.href} href={link.href} className='ft-link'>
                            {link.label}
                        </Link>
                    ))}
                </nav>
            </div>

            <p className='ft-note'>
                Este site oferece informação e orientação. Ele não substitui o atendimento
                dos serviços de saúde, de assistência social, de segurança e de justiça.
            </p>
        </footer>
    )
}
